import { formatRenderedCurrency } from 'utils/formatters/formatCurrency';

import type { AccountSummary } from 'api/customerApi';

import type { AccountDetailsField } from './types';

export const formatAccountDataToDetails = (
  accountData: AccountSummary
): Array<AccountDetailsField> => {
  return [
    {
      name: 'Closing',
      amount: formatRenderedCurrency(
        Number(accountData.closing_balance),
        accountData.currency_code ?? ''
      )
    },
    {
      name: 'Opening',
      amount: formatRenderedCurrency(
        Number(accountData.opening_balance),
        accountData.currency_code ?? ''
      )
    },
    {
      name: 'Current',
      amount: formatRenderedCurrency(
        Number(accountData.current_balance),
        accountData.currency_code ?? ''
      )
    }
  ];
};
